// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mQq1","colBig":"styles_colBig__2Rk-m","colSmall":"styles_colSmall__fKzCS","shopifyNameWrapper":"styles_shopifyNameWrapper__3jYBA"};